module.exports = __webpack_public_path__ + "static/media/openButton.98d82fef.svg";